import React from "react";
import { useTheme } from "@/contexts/ThemeContext";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ compact = false }) {
  const { theme, setTheme } = useTheme();
  const options = [
    { k: "dark", icon: Moon, label: "Dark" },
    { k: "light", icon: Sun, label: "Light" },
  ];
  return (
    <div
      className={`inline-flex items-center gap-1 rounded-md border border-[#1E293B] bg-[#050A14] p-0.5 ${compact ? "" : "w-full"}`}
      data-testid="theme-toggle"
      role="group"
      aria-label="Theme"
    >
      {options.map(({ k, icon: Icon, label }) => (
        <button
          key={k}
          type="button"
          onClick={() => setTheme(k)}
          data-testid={`theme-${k}`}
          className={`flex-1 flex items-center justify-center gap-1 font-mono text-[10px] tracking-widest py-1 px-2 rounded transition-colors ${
            theme === k
              ? "bg-[#007AFF]/15 text-[#F8FAFC] border border-[#007AFF]/40"
              : "text-[#94A3B8] border border-transparent hover:text-[#F8FAFC]"
          }`}
          title={label}
          aria-pressed={theme === k}
        >
          <Icon className="w-3 h-3" />
          {!compact && <span>{label}</span>}
        </button>
      ))}
    </div>
  );
}
